<template>
  <div class="index" v-if="pageShow">

    <v-headerr ref="headercom" />
    <div class="ind_ban">
      <div class="ind_ban_li" style="background:url('../../../static/img/index-bg.png') no-repeat center center;background-size: cover;">
        <div class="index_check_btn btnhover hide" @click="checkNow"></div>

        <div class="headBanner">
          <el-carousel indicator-position="outside" @change="focusCarousel">
            <el-carousel-item v-for="item in 3" :key="item">
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="loginForm waitLogin" v-if="!userLoginStatus">
        	<img class="loginQrcode" :src="personLoginQrcode" v-if="personLoginQrcode">
          <div class="loginFormTitle" v-if="personLoginQrcode">
            <img class="loginWeixin" src="../../../static/img/icon-weixin.png">
            <label class="weixinTitle">微信扫码登录</label>
          </div>
        	<div v-if="hasError" style="color:red;font-size:18px">{{loginTextInfo}}</div>
        </div>

        <div class="loginForm logined" v-else>
          <img class="icoLoginSucc" src="../../../static/img/qrcode-scan-succ.png">
          <div class="loginDesc">登录成功</div>
          <button @click="goPage('userReport')" class="loginBtn">检测中心</button>
        </div>

      </div>
    </div>

	<!-- Copycheck资源优势 -->
    <div class="descOutter">
    	<div class="descInner">
    		<div class="descHeader">
    			<img src="../../../static/img/xunhuan.png" alt="" class="descHeaderImg">
    			<div class="descHeaderDesc">CopyCheck资源优势</div>
    			<div class="descHeaderDesc2">数据截止2024年8月</div>
    		</div>
    		<div class="descContent indexBox1">
    			<div class="descContentItem greenBottom">
    				<div class="descContentItemTitle">500<span class="descContentItemTitleSpan">万+</span></div>
    				<div class="descContentItemDesc">学术论文</div>
    			</div>

    			<div class="descContentItem orangeBottom">
    				<div class="descContentItemTitle">8000<span class="descContentItemTitleSpan">万+</span></div>
    				<div class="descContentItemDesc">期刊论文</div>
    			</div>

    			<div class="descContentItem greenBottom">
    				<div class="descContentItemTitle">10<span class="descContentItemTitleSpan">亿+</span></div>
    				<div class="descContentItemDesc">网络资源</div>
    			</div>

    			<div class="descContentItem descContentItemend orangeBottom">
    				<div class="descContentItemTitle">8<span class="descContentItemTitleSpan">年+</span></div>
    				<div class="descContentItemDesc">累计服务学术时长</div>
    			</div>
    		</div>
    	</div>

      <div class="descInner descInner2">
        <div class="descHeader">
          <img src="../../../static/img/xunhuan.png" alt="" class="descHeaderImg">
          <div class="descHeaderDesc">CopyCheck检测优势</div>
          <div class="descHeaderDesc2">我们的6大优势</div>
        </div>
        <div class="descContent descContent2">
          <div class="descContentLsit bg1 btnhover">
            <div class="descContentLsitTitle">海量对比库</div>
            <div class="descContentLsitDesc">由超过8000万的学术期刊和学位论文以及一个超过10亿数量的互联网网页数据库组成。</div>
          </div>

          <div class="descContentLsit bg2 btnhover">
            <div class="descContentLsitTitle">专业算法模型</div>
            <div class="descContentLsitDesc">自主知识产权的全新检测算法，检测高效精准、速度快，给你不一般的体验。</div>
          </div>

          <div class="descContentLsit bg3 btnhover">
            <div class="descContentLsitTitle">分布式云计算</div>
            <div class="descContentLsitDesc">通过网络“云”，将巨大的数据计算处理程序分解成无数个小程序，再由多部服务器进行处理和分析。</div>
          </div>

          <div class="descContentLsit bg4 btnhover">
            <div class="descContentLsitTitle">安全传输协议</div>
            <div class="descContentLsitDesc">传输存储技术安全可靠，保护你的文献不被泄漏，检测过程放心安心。</div>
          </div>

          <div class="descContentLsit bg5 btnhover">
            <div class="descContentLsitTitle">直观图谱展示</div>
            <div class="descContentLsitDesc">多种知识图谱可视化分析，图解详细说明，图文结合，直观详尽。</div>
          </div>

          <div class="descContentLsit bg6 btnhover">
            <div class="descContentLsitTitle">性价比高</div>
            <div class="descContentLsitDesc">多种活动开放，多途径获取免费检测字数，您检测，我买单。</div>
          </div>

          <div class="clear"></div>
        </div>
      </div>
    </div>
    <!-- Copycheck资源优势 -->

    <div class="reportExample">
        <div class="descHeader">
          <img src="../../../static/img/xunhuan.png" alt="" class="descHeaderImg">
          <div class="descHeaderDesc">论文查重报告演示</div>
          <div class="descHeaderDesc2">多格式文件报告、多角度对比、多维度展示</div>
        </div>

        <div class="reportExampleDesc">
          <p class="reportExampleDescTitle">报告特点</p>
          <p class="reportExampleDescItem">1. 简洁报告、相似片段PDF报告、全文对照网页报告；</p>
          <p class="reportExampleDescItem">2. 标红文字一定要仔细查看，标黄文字可以粗略查看；</p>
          <p class="reportExampleDescItem">3. 区分论文中的标准引用的参考文献；</p>
          <div class="reportExampleShowBtn btnhover" @click="toExample()">开始演示</div>
        </div>

        <div class="reportExampleDescNav">
          <div @mouseover="descindexOption(1)" v-bind:class="[{'select': descindex == 1}, 'reportExampleDescNavItem']">全文对照网页报告</div>

          <div @mouseover="descindexOption(2)" v-bind:class="[{'select': descindex == 2}, 'reportExampleDescNavItem']">相似片段PDF报告</div>
          <div @mouseover="descindexOption(3)" v-bind:class="[{'select': descindex == 3}, 'reportExampleDescNavItem']">简洁PDF报告</div>
        </div>

        <div class="reportExampleImgOutter">
          <img v-if="descindex == 1" class="reportExampleImgImg" src="../../../static/img/report_html.png" alt="">

          <img v-if="descindex == 2" class="reportExampleImgImg" src="../../../static/img/copycheck_detail.jpg" alt="">

          <img v-if="descindex == 3" class="reportExampleImgImg" src="../../../static/img/copycheck_jianjie.jpg" alt="">
        </div>
    </div>

    <div class="userLiuyan" hidden>
      <div class="descHeader">
        <img src="../../../static/img/xunhuan.png" alt="" class="descHeaderImg">
        <div class="descHeaderDesc">用户留言</div>
        <div class="descHeaderDesc2">累计服务近千万人，大家的认可是我们前进的动力</div>
      </div>

      <div class="userCommentOut">
        <div class="userCommentPhone">{{phone}}</div>
        <div class="userCommentDate">{{date}}</div>
        <div class="userComment">{{text}}</div>
      </div>
      <div class="userAvatorList" :style="`margin-top:${userAvatorListMarginTop}px;`">
          <div @click="toAvator(0)" v-bind:class="[{'select': aindex == 0}, 'userAvatorListImg', 'userAvatorListImgFrist']" :style="`width:${userAvatorListImgWidth}px;height:${userAvatorListImgHeight}px;margin-right:${userAvatorListImgMarginRight}px;`+`${aindex==0?'width:'+userAvatorListImgSelectWidth+'px !important;height:'+userAvatorListImgSelectHeight+'px !important;border-width:'+userAvatorListImgSelectBorderWidth+'px !important;top:'+userAvatorListImgSelectTop+'px !important;':'width:'+userAvatorListImgWidth+'px !important;height:'+userAvatorListImgHeight+'px !important;top:0px !important!important;'}`">
            <img src="../../../static/img/1.jpg" alt="">
          </div>
          <div @click="toAvator(1)" v-bind:class="[{'select': aindex == 1}, 'userAvatorListImg', 'userAvatorListImgInner']" :style="`width:${userAvatorListImgWidth}px;height:${userAvatorListImgHeight}px;margin-right:${userAvatorListImgMarginRight}px;`+`${aindex==1?'width:'+userAvatorListImgSelectWidth+'px !important;height:'+userAvatorListImgSelectHeight+'px !important;border-width:'+userAvatorListImgSelectBorderWidth+'px !important;top:'+userAvatorListImgSelectTop+'px !important;margin-right:'+userAvatorListImgInnerMarginRight+'px !important;margin-left:'+userAvatorListImgInnerMarginLeft+'px !important;':'width:'+userAvatorListImgWidth+'px !important;height:'+userAvatorListImgHeight+'px !important;top:0px !important!important;margin-right:'+userAvatorListImgMarginRight+'px !important;margin-left:0px !important;'}`">
            <img src="../../../static/img/2.jpg" alt="">
          </div>
          <div @click="toAvator(2)" v-bind:class="[{'select': aindex == 2}, 'userAvatorListImg', 'userAvatorListImgInner']" :style="`width:${userAvatorListImgWidth}px;height:${userAvatorListImgHeight}px;margin-right:${userAvatorListImgMarginRight}px;`+`${aindex==2?'width:'+userAvatorListImgSelectWidth+'px !important;height:'+userAvatorListImgSelectHeight+'px !important;border-width:'+userAvatorListImgSelectBorderWidth+'px !important;top:'+userAvatorListImgSelectTop+'px !important;margin-right:'+userAvatorListImgInnerMarginRight+'px !important;margin-left:'+userAvatorListImgInnerMarginLeft+'px !important;':'width:'+userAvatorListImgWidth+'px !important;height:'+userAvatorListImgHeight+'px !important;top:0px !important!important;margin-right:'+userAvatorListImgMarginRight+'px !important;margin-left:0px !important;'}`">
            <img src="../../../static/img/3.jpg" alt="">
          </div>
          <div @click="toAvator(3)" v-bind:class="[{'select': aindex == 3}, 'userAvatorListImg', 'userAvatorListImgInner']" :style="`width:${userAvatorListImgWidth}px;height:${userAvatorListImgHeight}px;margin-right:${userAvatorListImgMarginRight}px;`+`${aindex==3?'width:'+userAvatorListImgSelectWidth+'px !important;height:'+userAvatorListImgSelectHeight+'px !important;border-width:'+userAvatorListImgSelectBorderWidth+'px !important;top:'+userAvatorListImgSelectTop+'px !important;margin-right:'+userAvatorListImgInnerMarginRight+'px !important;margin-left:'+userAvatorListImgInnerMarginLeft+'px !important;':'width:'+userAvatorListImgWidth+'px !important;height:'+userAvatorListImgHeight+'px !important;top:0px !important!important;margin-right:'+userAvatorListImgMarginRight+'px !important;margin-left:0px !important;'}`">
            <img src="../../../static/img/4.jpg" alt="">
          </div>
          <div @click="toAvator(4)" v-bind:class="[{'select': aindex == 4}, 'userAvatorListImg', 'userAvatorListImgInner']" :style="`width:${userAvatorListImgWidth}px;height:${userAvatorListImgHeight}px;margin-right:${userAvatorListImgMarginRight}px;`+`${aindex==4?'width:'+userAvatorListImgSelectWidth+'px !important;height:'+userAvatorListImgSelectHeight+'px !important;border-width:'+userAvatorListImgSelectBorderWidth+'px !important;top:'+userAvatorListImgSelectTop+'px !important;margin-right:'+userAvatorListImgInnerMarginRight+'px !important;margin-left:'+userAvatorListImgInnerMarginLeft+'px !important;':'width:'+userAvatorListImgWidth+'px !important;height:'+userAvatorListImgHeight+'px !important;top:0px !important!important;margin-right:'+userAvatorListImgMarginRight+'px !important;margin-left:0px !important;'}`">
            <img src="../../../static/img/5.jpg" alt="">
          </div>
          <div @click="toAvator(5)" v-bind:class="[{'select': aindex == 5}, 'userAvatorListImg', 'userAvatorListImgInner']" :style="`width:${userAvatorListImgWidth}px;height:${userAvatorListImgHeight}px;margin-right:${userAvatorListImgMarginRight}px;`+`${aindex==5?'width:'+userAvatorListImgSelectWidth+'px !important;height:'+userAvatorListImgSelectHeight+'px !important;border-width:'+userAvatorListImgSelectBorderWidth+'px !important;top:'+userAvatorListImgSelectTop+'px !important;margin-right:'+userAvatorListImgInnerMarginRight+'px !important;margin-left:'+userAvatorListImgInnerMarginLeft+'px !important;':'width:'+userAvatorListImgWidth+'px !important;height:'+userAvatorListImgHeight+'px !important;top:0px !important!important;margin-right:'+userAvatorListImgMarginRight+'px !important;margin-left:0px !important;'}`">
            <img src="../../../static/img/6.jpg" alt="">
          </div>
          <div @click="toAvator(6)" v-bind:class="[{'select': aindex == 6}, 'userAvatorListImg', 'userAvatorListImgEnd']" :style="`width:${userAvatorListImgWidth}px;height:${userAvatorListImgHeight}px;margin-right:${userAvatorListImgMarginRight}px;`+`${aindex==6?'width:'+userAvatorListImgSelectWidth+'px !important;height:'+userAvatorListImgSelectHeight+'px !important;border-width:'+userAvatorListImgSelectBorderWidth+'px !important;top:'+userAvatorListImgSelectTop+'px !important;margin-right:'+userAvatorListImgInnerMarginRight+'px !important;margin-left:'+userAvatorListImgInnerMarginLeft+'px !important;':'width:'+userAvatorListImgWidth+'px !important;height:'+userAvatorListImgHeight+'px !important;top:0px !important!important;margin-right:'+userAvatorListImgMarginRight+'px !important;margin-left:0px !important;'}`">
            <img src="../../../static/img/7.jpg" alt="">
          </div>
          <div class="clear"></div>
        </div>
    </div>

    <div class="paperDescListOutter">
      <div class="descHeader">
        <img src="../../../static/img/xunhuan.png" alt="" class="descHeaderImg">
        <div class="descHeaderDesc">论文查重常见问题</div>
      </div>

      <div>
        <div class="paperDescList paperDescListFirst">
          <div class="paperDescListTitle" @click="expandDesc(0)">我的论文检测已通过了，怎么还被取消了答辩资格？
            <div class="paperDescListTitleIcon">
              <img src="../../../static/img/shou2.png" alt="" class="shou2">
              <img src="../../../static/img/shou1.png" alt="" class="shou1 hide">
              <img src="../../../static/img/zhan1.png" alt="" class="zhan1 hide">
            </div>
          </div>
          <div class="paperDescListContent dh">
		一定要注意，检测论文只是学校论文答辩前的一个初步筛选环节。检测通过之后，评审老师还要审查论文的内容。如果论文内容言之无物，而且句子都不通顺。想蒙骗过关的话，取消答辩资格是很正常的！</div>
         </div>

         <div class="paperDescList">
          <div class="paperDescListTitle" @click="expandDesc(1)">系统支持文字、公式、表格、图片格式的内容的检测吗？
            <div class="paperDescListTitleIcon">
              <img src="../../../static/img/shou2.png" alt="" class="shou2">
              <img src="../../../static/img/shou1.png" alt="" class="shou1 hide">
              <img src="../../../static/img/zhan1.png" alt="" class="zhan1 hide">
            </div>
          </div>

          <div class="paperDescListContent dh">
		文字复制是学术不端行为中最为普遍和严重的，目前本检测系统对文字复制的检测已经达到相当高的水平。但是对公式、表格和图片暂时无法准确比对。目前研发人员对如上3种内容还在探索中，欢迎继续关注并多提宝贵的意见和建议。</div>
        </div>

        <div class="paperDescList">
          <div class="paperDescListTitle" @click="expandDesc(2)">论文引用怎么标注？
            <div class="paperDescListTitleIcon">
              <img src="../../../static/img/shou2.png" alt="" class="shou2">
              <img src="../../../static/img/shou1.png" alt="" class="shou1 hide">
              <img src="../../../static/img/zhan1.png" alt="" class="zhan1 hide">
            </div>
          </div>
          <div class="paperDescListContent dh">
    论文中引用他人的文献应当按照参考文献的国家标准格式依次进行引用和标注。格式如下：<br/>
		参考文献(即引文出处)的类型以单字母方式标识，具体如下： M――专著 C――论文集 N――报纸文章 J――期刊文章 D――学位论文 R――报告 对于不属于上述的文献类型，采用字母“Z”标识。<br/>

		1.期刊类<br/>
		【格式】[序号]作者.篇名[J].刊名，出版年份，卷号(期号)：起止页码.<br/>

		【举例】<br/>
		[1] 王海粟.浅议会计信息披露模式[J].财政研究，2004,21(1)：56-58.<br/>
		[2] 夏鲁惠.高等学校毕业论文教学情况调研报告[J].高等理科教育，2004(1):46-52.<br/>

		2.专著类<br/>
		【格式】[序号]作者.书名[M].出版地：出版社，出版年份：起止页码.<br/>

		【举例】<br/>
		[3] 葛家澍，林志军.现代西方财务会计理论[M].厦门：厦门大学出版社，2001：42.<br/>
		[4] Gill, R. Mastering English Literature [M]. London: Macmillan, 1985: 42-45.<br/>

		3.报纸类<br/>
		【格式】[序号]作者.篇名[N].报纸名，出版日期(版次).<br/>

		【举例】<br/>
		[5] 李大伦.经济全球化的重要性[N]. 光明日报，1998-12-27(3).<br/>

		4.论文集<br/>
		【格式】[序号]作者.篇名[C].出版地：出版者，出版年份：起始页码.<br/>

		【举例】<br/>
		[6] 伍蠡甫.西方文论选[C]. 上海：上海译文出版社，1979：12-17.<br/>

		5.学位论文<br/>
		【格式】[序号]作者.篇名[D].出版地：保存者，出版年份：起始页码.<br/>

		【举例】<br/>
		[11] 张筑生.微分半动力系统的不变集[D].北京：北京大学数学系数学研究所, 1983：1-7.<br/>

		6.研究报告<br/>
		【格式】[序号]作者.篇名[R].出版地：出版者，出版年份：起始页码.<br/>

		【举例】<br/>
		[12] 冯西桥.核反应堆压力管道与压力容器的LBB分析[R].北京：清华大学核能技术设计研究院, 1997：9-10.<br/>

		7.条例<br/>
		【格式】[序号]颁布单位.条例名称.发布日期<br/>

		【举例】<br/>
		[15] 中华人民共和国科学技术委员会.科学技术期刊管理办法[Z].1991―06―05<br/>

		8.译著<br/>
		【格式】[序号]原著作者. 书名[M].译者，译.出版地：出版社，出版年份：起止页码.<br/>

		</div>
        </div>

        <div class="paperDescList">
          <div class="paperDescListTitle" @click="expandDesc(3)">相似比超过多少会被认定为抄袭？
            <div class="paperDescListTitleIcon">
              <img src="../../../static/img/shou2.png" alt="" class="shou2">
              <img src="../../../static/img/shou1.png" alt="" class="shou1 hide">
              <img src="../../../static/img/zhan1.png" alt="" class="zhan1 hide">
            </div>
          </div>
          <div class="paperDescListContent dh">不同的学校的规定有差异，有的学校重复率30%以下，有的学校要求在20%以下，有的学校规定在10%以下；而学术期刊一般不超过30%，否则会直接退稿。具体规定请参照各单位要求。</div>
        </div>

        <div class="paperDescList">
          <div class="paperDescListTitle" @click="expandDesc(4)">我的论文在copycheck检测后是否安全？
            <div class="paperDescListTitleIcon">
              <img src="../../../static/img/shou2.png" alt="" class="shou2">
              <img src="../../../static/img/shou1.png" alt="" class="shou1 hide">
              <img src="../../../static/img/zhan1.png" alt="" class="zhan1 hide">
            </div>
          </div>
          <div class="paperDescListContent dh">
		公司制定了严格的论文保密制度，对用户提交的送检文档仅做检测分析，绝不保留全文，承诺对用户送检的文档不做任何形式的收录和泄露。</div>
        </div>

        <div class="paperDescList">
          <div class="paperDescListTitle" @click="expandDesc(5)">提交论文后多久能获得检测报告？
            <div class="paperDescListTitleIcon">
              <img src="../../../static/img/shou2.png" alt="" class="shou2">
              <img src="../../../static/img/shou1.png" alt="" class="shou1 hide">
              <img src="../../../static/img/zhan1.png" alt="" class="zhan1 hide">
            </div>
          </div>
          <div class="paperDescListContent dh">
		正常情况下万字以内的论文，检测耗时10分钟左右，检测时间与论文长短、排队检测的文档多少有一定关系，在检测高峰期有时会出现几个小时的排队情况。</div>
        </div>
      </div>
    </div>

    <div class="friendLinkOutter">
      <div class="friendLink1">
        <div class="descHeader">
          <img src="../../../static/img/xunhuan.png" alt="" class="descHeaderImg">
          <div class="descHeaderDesc">合作伙伴</div>
        </div>

        <div class="friendLinkCompany">
          <div class="friendLinkCompanyItem school_logo1 btnhover">
            <img src="../../../static/img/sc1.png" alt="" >
          </div>
          <div class="friendLinkCompanyItem school_logo2 btnhover">
            <img src="../../../static/img/sc2.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo3 btnhover">
            <img src="../../../static/img/sc3.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo4 btnhover">
            <img src="../../../static/img/sc4.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo5 btnhover">
            <img src="../../../static/img/sc5.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo6 btnhover">
            <img src="../../../static/img/sc6.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo7 btnhover">
            <img src="../../../static/img/sc7.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo8 btnhover">
            <img src="../../../static/img/sc8.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo9 btnhover">
            <img src="../../../static/img/sc9.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo10 btnhover">
            <img src="../../../static/img/sc10.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo11 btnhover">
            <img src="../../../static/img/sc11.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo12 btnhover">
            <img src="../../../static/img/sc12.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo13 btnhover">
            <img src="../../../static/img/sc13.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo14 btnhover">
            <img src="../../../static/img/sc14.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo15 btnhover">
            <img src="../../../static/img/sc15.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo16 btnhover">
            <img src="../../../static/img/sc16.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo17 btnhover">
            <img src="../../../static/img/sc17.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo18 btnhover">
            <img src="../../../static/img/sc18.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo19 btnhover">
            <img src="../../../static/img/sc19.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo20 btnhover">
            <img src="../../../static/img/sc20.png" alt="">
          </div>
          <div class="friendLinkCompanyItem school_logo21 btnhover">
            <img src="../../../static/img/sc21.png" alt="">
          </div>
        </div>
      </div>

      <div  class="friendLink2" hidden>
        <div class="descHeader">
          <img src="../../../static/img/xunhuan.png" alt="" class="descHeaderImg">
          <div class="descHeaderDesc">友情链接</div>
        </div>
        <div class="friendLink2List">
          <a href="">论文网</a>
          <a href="">简历</a>
          <a href="">期刊论文</a>
          <a href="">美国留学</a>
          <a href="">中国期刊网</a>
          <a href="">论文下载</a>
          <a href="">发表论文</a>
          <a href="">论文发表</a>
          <a href="">考研网 </a>
          <a href="">在职研究生</a>
          <a href="">美术高考网</a>
          <a href="">会计实操毕业论文</a>
          <a href="">中文期刊网</a>
        </div>
      </div>
    </div>

    <div class="jifenhuodongMask hide" @click="checkNow()">

    </div>
    <img src="../../../static/img/jifenhuodong.jpg" alt="" class="jifenhuodongMaskImg hide">
    <img class="closejifen hide" @click="checkNow()" src="../../../static/img/close.png" alt="">
    <div class="jifenDescCon hide">
      <div>
        <p></p>
        每日登录获得1个积分
      </div>
      <div><p></p>每个用户注册后获得3个积分</div>
      <div><p></p>邀请用户注册获得5个积分</div>
      <div><p></p>在“我的自建库”里，可以上传引用过的论文，并加入共享文献库，每1篇获得10个积分</div>
      <div><p></p>推荐的人上次文献授权，也会赠送推荐人相应的积分</div>
      <div><p></p>付费用户下载授权文献也有积分</div>
      <div><p></p>在”我的学术集“里，通过姓名和单位搜索到文献，授权给copycheck，每一篇获得10个积分。如果通过搜索未找到自己发表的论文，可以上传。</div>
    </div>

    <div class="goCheckOutter">
      <div class="goCheckDesc">“ 500万大学生都在用的论文查重平台 ”</div>
      <div class="goCheckBtn btnhover" @click="scrollToTop()">立即检测</div>
    </div>

    <!-- <div class="ind_md" v-if="ind_md_cx">
      <div v-for="(item,idx) in ind_md" :class="{ind_md_ac:ind_mdnum==idx}" @click="qiemd(idx)">
        <span></span>
        <p>{{ item.name }}</p>
      </div>
    </div> -->

    <!-- 首页VIP购买广告横幅 begin -->
    <!-- <div class="ind_vip_banner" v-show="isShowVipBanner">
      <img src="../../../static/img/vip_ad2.png" @click="showVipPayBanner" alt="" class="vip_banner">
      <img src="../../../static/img/icon_close_circle2.png" class="ico_close" @click="closeVipBanner">
    </div> -->
    <!-- 首页VIP购买广告横幅 end -->

    <tplKefu />
    <v-footerr ref="footercom" />

    <pay-banner :show.sync="isShowVipPayBanner" ref="paybanner"></pay-banner>
  </div>
</template>

<script>
import Headerr from "../Headerr.vue";
import Footerr from "../Footerr.vue";
import Kefu from "../Kefu.vue";
import vipPayBanner from "../User/VipPay/Banner.vue";

import { defaultData, userLevels, isMobile, siteInfos } from "../../assets/js/common";
import {
  _user_get_login_qrcode,
  _user_get_page_uuid,
  _user_ajax_login_verify,
  _user_get_info,
} from "../../api";
import axios from "axios";

export default {
  name: "indexNew",
  components: {
    "v-footerr": Footerr,
    "v-headerr": Headerr,
    tplKefu: Kefu,
    "pay-banner": vipPayBanner,
  },
  data() {
    return {
      pageShow: true,
      epopInterVal: null,
      aindex:1,
      phone:'18279****32',
      date:'2020-01-29 16:25:16',
      userAvatorListMarginTop:this.calcSizeWidthHeight(51),
      avator_url:'',
      nickName:'',
      text:'挺好用的，提交之前查一下比较保险。提交之后大概需要等几分钟才能出结果，内容里面写的很详细，报告也很漂亮。性价比还是比较高的，我原本重复率30%，改了几次以后，终于改到了8%，我这一篇4000多个字，几块钱的检测价格，不算贵，关键学校也是用这个检测系统来验证的，提前检测很放心。',
      fwxz: [
        {
          phone: "18279****32",
          date: "2020-01-29 16:25:16",
          text:
            "挺好用的，提交之前查一下比较保险。提交之后大概需要等几分钟才能出结果，内容里面写的很详细，报告也很漂亮。性价比还是比较高的，我原本重复率30%，改了几次以后，终于改到了8%，我这一篇4000多个字，几块钱的检测价格，不算贵，关键学校也是用这个检测系统来验证的，提前检测很放心。",
        },
        {
          phone: "13856****72",
          date: "2020-02-03 12:23:42",
          text:
            "挺好用的，提交之前查一下比较保险。提交之后大概需要等几分钟才能出结果，内容里面写的很详细，报告也很漂亮。性价比还是比较高的，我原本重复率30%，改了几次以后，终于改到了8%，我这一篇4000多个字，几块钱的检测价格，不算贵，关键学校也是用这个检测系统来验证的，提前检测很放心。",
        },
        {
          phone: "13398*****33",
          date: "2020-05-18 17:21:38",
          text: "挺好用的，提交之前查一下比较保险。提交之后大概需要等几分钟才能出结果，内容里面写的很详细，报告也很漂亮。性价比还是比较高的，我原本重复率30%，改了几次以后，终于改到了8%，我这一篇4000多个字，几块钱的检测价格，不算贵，关键学校也是用这个检测系统来验证的，提前检测很放心。",
        },
        {
          phone: "13145****48",
          date: "2020-05-19 13:05:29",
          text:
            "挺好用的，提交之前查一下比较保险。提交之后大概需要等几分钟才能出结果，内容里面写的很详细，报告也很漂亮。性价比还是比较高的，我原本重复率30%，改了几次以后，终于改到了8%，我这一篇4000多个字，几块钱的检测价格，不算贵，关键学校也是用这个检测系统来验证的，提前检测很放心。",
        },
        {
          phone: "13145****48",
          date: "2020-05-19 13:05:29",
          text:
            "挺好用的，提交之前查一下比较保险。提交之后大概需要等几分钟才能出结果，内容里面写的很详细，报告也很漂亮。性价比还是比较高的，我原本重复率30%，改了几次以后，终于改到了8%，我这一篇4000多个字，几块钱的检测价格，不算贵，关键学校也是用这个检测系统来验证的，提前检测很放心。",
        },
        {
          phone: "18279****32",
          date: "2020-01-29 16:25:16",
          text:
            "挺好用的，提交之前查一下比较保险。提交之后大概需要等几分钟才能出结果，内容里面写的很详细，报告也很漂亮。性价比还是比较高的，我原本重复率30%，改了几次以后，终于改到了8%，我这一篇4000多个字，几块钱的检测价格，不算贵，关键学校也是用这个检测系统来验证的，提前检测很放心。",
        },
        {
          phone: "13856****72",
          date: "2020-02-03 12:23:42",
          text:
            "挺好用的，提交之前查一下比较保险。提交之后大概需要等几分钟才能出结果，内容里面写的很详细，报告也很漂亮。性价比还是比较高的，我原本重复率30%，改了几次以后，终于改到了8%，我这一篇4000多个字，几块钱的检测价格，不算贵，关键学校也是用这个检测系统来验证的，提前检测很放心。",
        },
        {
          phone: "13398*****33",
          date: "2020-05-18 17:21:38",
          text: "挺好用的，提交之前查一下比较保险。提交之后大概需要等几分钟才能出结果，内容里面写的很详细，报告也很漂亮。性价比还是比较高的，我原本重复率30%，改了几次以后，终于改到了8%，我这一篇4000多个字，几块钱的检测价格，不算贵，关键学校也是用这个检测系统来验证的，提前检测很放心。",
        },
        {
          phone: "13145****48",
          date: "2020-05-19 13:05:29",
          text:
            "挺好用的，提交之前查一下比较保险。提交之后大概需要等几分钟才能出结果，内容里面写的很详细，报告也很漂亮。性价比还是比较高的，我原本重复率30%，改了几次以后，终于改到了8%，我这一篇4000多个字，几块钱的检测价格，不算贵，关键学校也是用这个检测系统来验证的，提前检测很放心。",
        },
        {
          phone: "13145****48",
          date: "2020-05-19 13:05:29",
          text:
            "挺好用的，提交之前查一下比较保险。提交之后大概需要等几分钟才能出结果，内容里面写的很详细，报告也很漂亮。性价比还是比较高的，我原本重复率30%，改了几次以后，终于改到了8%，我这一篇4000多个字，几块钱的检测价格，不算贵，关键学校也是用这个检测系统来验证的，提前检测很放心。",
        },
      ],
      widthh: "200",
      ind_md: [
        { name: "为什么选择我们" },
        { name: "服务千万学子" },
        { name: "CopyCheck检测优势" },
        { name: "如何查看报告" },
        { name: "我们的一些建议" },
      ],
      ind_mdnum: "0",
      pos: 0,
      ind_md_cx: false,
      fwxz_lb_item: "",
      copycheckURL: defaultData.copycheckURL,
      centerDialogVisible: false, // 模态框是否显示
      personLoginQrcode: "",
      userLoginStatus: false,
      check_login_timer: {}, // 查询登录状态的定时器
      loginTextTitle: "请点击刷新",
      loginTextInfo: "",
      userLevel: userLevels.USER,
      hasError: false, // 请求二维码时，是否有错误
      isShowGuiderPic: false, // 是否显示引导关注公众号的图片
      isShowVipBanner: false, // 是否显示VIP购买的横幅
      isShowVipPayBanner: false, // 是否显示vip购买的banner
      isClickedVipBanner: false, // 是否点击了广告
      descindex:1,
      isShowjifenhuodong:false,
      userAvatorListImgWidth:this.calcSizeWidthHeight(119),
      userAvatorListImgHeight:this.calcSizeWidthHeight(119),
      userAvatorListImgMarginRight:this.calcSizeWidthHeight(33),
      userAvatorListImgSelectWidth:this.calcSizeWidthHeight(146),
      userAvatorListImgSelectHeight:this.calcSizeWidthHeight(146),
      userAvatorListImgSelectBorderWidth:this.calcSizeWidthHeight(4),
      userAvatorListImgSelectTop:this.calcSizeWidthHeight(-14),
      userAvatorListImgInnerMarginRight:this.calcSizeWidthHeight(19),
      userAvatorListImgInnerMarginLeft:this.calcSizeWidthHeight(-14),
      domain:siteInfos.domain,
    };
  },
  methods: {
    createUserLoginQrcode(pageUuid) {
      this.ajaxLoginVerify(pageUuid);
      var param = new Object();
      param.unionid_page_id = pageUuid;
      var invite_uid = this.$route.query.f;
      //邀请人uid
      if(invite_uid && invite_uid>0) {
        param.invite_uid = invite_uid;
        this.$Cookies.set("invite_uid", invite_uid, {
          expires: 100,
          domain: window.cookieDomain,
        });
      }else{
        invite_uid = this.$Cookies.get("invite_uid", {domain: window.cookieDomain});
        if(invite_uid && invite_uid>0) param.invite_uid = invite_uid;
      }
      _user_get_login_qrcode(param)
        .then((res) => {
          this.ajaxLoginVerify(pageUuid);
          this.personLoginQrcode = res;
          this.hasError = false;
          // 前端判定2分钟超时，不再进行请求登录，并提示用户
          let that = this;
          setTimeout(() => {
            that.hasError = true;
            this.loginTextInfo = "";
            window.clearInterval(that.check_login_timer);
          }, 1000 * 60 * 2);
        })
        .catch((err) => {
          this.loginTextInfo = err.info;
          this.hasError = true;
          window.clearInterval(this.check_login_timer);
        });
    },
    getPageUuid() {
      _user_get_page_uuid()
        .then((res) => {
          this.createUserLoginQrcode(res);
          this.hasError = false;
        })
        .catch((err) => {
          this.loginTextInfo = err.info;
          this.hasError = true;
        });
    },
    ajaxLoginVerify(pageUuid) {
      let that = this;
      window.clearInterval(that.check_login_timer);
      that.check_login_timer = setInterval(function () {
        let option = "login";
        _user_ajax_login_verify({ unionid_page_id: pageUuid, option: option })
          .then((res) => {
            if (res.useruid && res.userstr) {
              that.$Cookies.set("useruid", res.useruid, {
                expires: 7,
                domain: window.cookieDomain,
              });
              that.$Cookies.set("userstr", res.userstr, {
                expires: 7,
                domain: window.cookieDomain,
              });
              that.$Cookies.set("userlevel", res.level, {
                expires: 7,
                domain: window.cookieDomain,
              });
              that.$Cookies.set("nick", res.nick, {
                expires: 7,
                domain: window.cookieDomain,
              });

              //删除推荐人uid
              that.$Cookies.remove("invite_uid", { domain: window.cookieDomain });

              // 修改相关状态
              that.userLevel = res.level;
              that.centerDialogVisible = false;
              that.onLoginDialogClose();
              that.userLoginStatus = true;
              that.$message.success("恭喜您登录成功!");
              that.hasError = false;

              // 如果点击来广告横幅则直接显示
              if (that.isClickedVipBanner) {
                that.isShowVipPayBanner = true;
                this.$refs.paybanner.renderGoodsList();
                return;
              }

              // 如果是VIP会员，则直接跳转页面
              setTimeout(function () {
                let redirect_url = that.$Cookies.get("_user_redirect_url");
                if (!redirect_url) redirect_url = "/userReport";
                location.href = redirect_url;
              }, 1000);
            }
          })
          .catch((err) => {
            // that.loginTextTitle = "登陆失败";
            that.loginTextInfo = err.info;
            that.hasError = true;
          });
      }, 2000);
    },
    checkNow() {
      this.isShowjifenhuodong = !this.isShowjifenhuodong;
      if(this.isShowjifenhuodong){
        $('.jifenhuodongMask').show();
        $('.closejifen').show();
        $('.jifenhuodongMaskImg').show();
        $('.jifenDescCon').show();

      }else{
        $('.jifenhuodongMask').hide();
        $('.closejifen').hide();
        $('.jifenhuodongMaskImg').hide();
        $('.jifenDescCon').hide();
      }
    },
    logout(){
      // 未登录或则登录已失效，删除cookie和store
      this.$Cookies.remove("useruid", { domain: window.cookieDomain });
      this.$Cookies.remove("userstr", { domain: window.cookieDomain });
      this.$Cookies.remove("userlevel", { domain: window.cookieDomain });
      this.$store.state.user = {};
      // 弹出微信登录二维码
      this.centerDialogVisible = true;
      this.getLoginQrcode();
      $('.logined').hide();
      $('.waitLogin').show();
    },
    getLoginQrcode() {
      let that = this;
      _user_get_info()
        .then((res) => {
          // 已登录，直接跳转
          // that.$router.push({ path: "/userReport" });
          $('.waitLogin').hide();
          $('.logined').show();
          this.avator_url = res.avator_url;
          this.nickName = res.nick;
          that.styleInit()
      })
      .catch((err) => {
        // 未登录或则登录已失效，删除cookie和store
        this.$Cookies.remove("useruid", { domain: window.cookieDomain });
        this.$Cookies.remove("userstr", { domain: window.cookieDomain });
        this.$Cookies.remove("userlevel", { domain: window.cookieDomain });
        this.$store.state.user = {};
        // 弹出微信登录二维码
        that.centerDialogVisible = true;
        that.getPageUuid();
      });
    },
    onLoginDialogClose() {
      window.clearInterval(this.check_login_timer);
      this.personLoginQrcode = false;
    },
    onChange(index) {

    },
    toExample() {
      window.open("//"+this.domain+"/report_example/");
    },
    scrollToTop() {
      window.scrollTo({
          left: 0,
          top: 0,
          behavior: 'smooth'
      });
    },
    descindexOption(index){
      this.descindex = index;
    },
    mouseMoveIn() {
      if (this.hasError) return;
      this.isShowGuiderPic = true;
    },
    prevv() {
      this.$refs.ind_ban.prev();
    },
    nextt() {
      this.$refs.ind_ban.next();
    },
    mouseMoveOut() {
      if (this.hasError) return;
      this.isShowGuiderPic = false;
    },
    closeVipBanner() {
      this.isShowVipBanner = false;
      var expire = new Date().getTime() + 1000 * 60 * 60 * 1; // 1小时内不显示
      this.$Cookies.set("vip_banner_expire", expire);
    },
    showVipPayBanner() {
      this.isClickedVipBanner = true;
      let userstr = this.$Cookies.get('userstr');
      if (userstr) {
        this.isShowVipPayBanner = true;
        this.$refs.paybanner.renderGoodsList();
        return;
      }
      this.checkNow();
    },
    styleInit(){
      var swiperHeight = document.body.clientWidth / (1920 / 400);
        document.getElementsByClassName("ind_ban_li")[0].style.height = swiperHeight + "px";
        document.getElementsByClassName("index_check_btn")[0].style.top = swiperHeight * (401 / 600) + "px";
        document.getElementsByClassName("index_check_btn")[0].style.left = document.body.clientWidth * (245 / 1920) + "px";
          document.getElementsByClassName("index_check_btn")[0].style.width = document.body.clientWidth * (268 / 1903) + "px";
          document.getElementsByClassName("index_check_btn")[0].style.fontSize = document.body.clientWidth * (34 / 1903) + "px";
          document.getElementsByClassName("index_check_btn")[0].style.lineHeight = document.body.clientWidth * (77 / 1903) + "px";
        document.getElementsByClassName("index_check_btn")[0].style.height = document.body.clientWidth * (77 / 1903) + "px";

        if(document.getElementsByClassName("loginForm")[0]) {
          document.getElementsByClassName("loginForm")[0].style.top = swiperHeight * (220 / 595) + "px";
          document.getElementsByClassName("loginForm")[0].style.right = document.body.clientWidth * (320 / 1920) + "px";
          document.getElementsByClassName("loginForm")[0].style.height = document.body.clientWidth * (196 / 1903) + "px";
          document.getElementsByClassName("loginForm")[0].style.width = document.body.clientWidth * (196 / 1903) + "px";
        }

        if(document.getElementsByClassName("loginForm")[1]) {
          document.getElementsByClassName("loginForm")[1].style.top = swiperHeight * (190 / 595) + "px";
          document.getElementsByClassName("loginForm")[1].style.right = document.body.clientWidth * (320 / 1920) + "px";
          document.getElementsByClassName("loginForm")[1].style.height = document.body.clientWidth * (196 / 1903) + "px";
          document.getElementsByClassName("loginForm")[1].style.width = document.body.clientWidth * (196 / 1903) + "px";
        }

        var clientWidth = document.body.clientWidth;

        $('ind_ban_li').css('height', this.calcSizeWidthHeight(595)+"px");
        var ind_ban = document.getElementsByClassName("ind_ban")[0].style;
        ind_ban.marginTop = clientWidth * (70.37/1903)+"px";

        $('.descOutter').height(this.calcSizeWidthHeight(1090)+"px");
        $('.descInner').width(this.calcSizeWidthHeight(1388)+"px");
        $('.ind_head_n').width(this.calcSizeWidthHeight(1388)+"px");
        $('.descInner').css('margin-top', this.calcSizeWidthHeight(78.9)+"px");
        $('.descHeader').height(this.calcSizeWidthHeight(64.43)+"px");
        $('.descHeaderImg').width(this.calcSizeWidthHeight(35)+"px");
        $('.descHeaderImg').height(this.calcSizeWidthHeight(35)+"px");
        $('.descHeaderDesc').css('line-height', this.calcSizeWidthHeight(36)+"px");
        $('.descHeaderDesc').css('font-size', this.calcSizeWidthHeight(36)+"px");
        $('.descHeaderDesc').css('padding-left', this.calcSizeWidthHeight(44.599999999999994)+"px");
        $('.descHeaderDesc2').css('line-height', this.calcSizeWidthHeight(16)+"px");
        $('.descHeaderDesc2').css('font-size', this.calcSizeWidthHeight(16)+"px");
        $('.descHeaderDesc2').css('padding-left', this.calcSizeWidthHeight(44.599999999999994)+"px");
        $('.descHeaderDesc2').css('margin-top', this.calcSizeWidthHeight(10.9)+"px");
        $('.descContent2').css('margin-top', this.calcSizeWidthHeight(39.65)+"px");
        $('.descContentItem').css('width', this.calcSizeWidthHeight(265.33)+"px");
        $('.descContentItem').css('height', this.calcSizeWidthHeight(132.71)+"px");
        $('.descContentItem').css('margin-right', this.calcSizeWidthHeight(15)+"px");
        $('.descContentItem').css('margin-top', this.calcSizeWidthHeight(93.17)+"px");
        $('.descContentItemTitle').css('height', this.calcSizeWidthHeight(45.59)+"px");
        $('.descContentItemTitle').css('font-size', this.calcSizeWidthHeight(59)+"px");
        $('.descContentItemTitle').css('line-height', this.calcSizeWidthHeight(45.59)+"px");
        $('.descContentItemTitleSpan').css('font-size', this.calcSizeWidthHeight(20)+"px");
        $('.descContentItemDesc').css('font-size', this.calcSizeWidthHeight(16)+"px");
        $('.descContentItemDesc').css('line-height', this.calcSizeWidthHeight(16)+"px");
        $('.descContentItemDesc').css('margin-top', this.calcSizeWidthHeight(16.85)+"px");
        $('.descInner2').css('margin-top', this.calcSizeWidthHeight(99.2)+"px");
        $('.descContentLsit').css('width', this.calcSizeWidthHeight(446)+"px");
        $('.descContentLsit').css('height', this.calcSizeWidthHeight(199)+"px");
        $('.descContentLsit').css('padding-top', this.calcSizeWidthHeight(53.52)+"px");
        $('.descContentLsit').css('padding-left', this.calcSizeWidthHeight(40.64)+"px");
        $('.descContentLsit').css('padding-right', this.calcSizeWidthHeight(35.68)+"px");
        $('.descContentLsit').css('margin-right', this.calcSizeWidthHeight(24.78)+"px");
        $('.descContentLsit').find('.bg4').css('margin-top', this.calcSizeWidthHeight(26.46)+"px");
        $('.descContentLsit').find('.bg5').css('margin-top', this.calcSizeWidthHeight(26.46)+"px");
        $('.descContentLsit').find('.bg6').css('margin-top', this.calcSizeWidthHeight(26.46)+"px");
        $('.descContentLsitTitle').css('line-height', this.calcSizeWidthHeight(20)+"px");
        $('.descContentLsitTitle').css('height', this.calcSizeWidthHeight(20)+"px");
        $('.descContentLsitTitle').css('font-size', this.calcSizeWidthHeight(20)+"px");
        $('.descContentLsitDesc').css('font-size', this.calcSizeWidthHeight(16)+"px");
        $('.descContentLsitDesc').css('line-height', this.calcSizeWidthHeight(25)+"px");
        $('.descContentLsitDesc').css('margin-top', this.calcSizeWidthHeight(25.77)+"px");

        $('.bg1').css('background-size', this.calcSizeWidthHeight(129)+"px auto");
        $('.bg1').css('background-position-x', this.calcSizeWidthHeight(309)+"px");
        $('.bg1').css('background-position-y', this.calcSizeWidthHeight(27)+"px");

        $('.bg2').css('background-size', this.calcSizeWidthHeight(184)+"px auto");
        $('.bg2').css('background-position-x', this.calcSizeWidthHeight(237)+"px");
        $('.bg2').css('background-position-y', this.calcSizeWidthHeight(31)+"px");

        $('.bg3').css('background-size', this.calcSizeWidthHeight(152)+"px auto");
        $('.bg3').css('background-position-x', this.calcSizeWidthHeight(269)+"px");
        $('.bg3').css('background-position-y', this.calcSizeWidthHeight(37)+"px");

        $('.bg4').css('background-size', this.calcSizeWidthHeight(126)+"px auto");
        $('.bg4').css('background-position-x', this.calcSizeWidthHeight(306)+"px");
        $('.bg4').css('background-position-y', this.calcSizeWidthHeight(20)+"px");

        $('.bg5').css('background-size', this.calcSizeWidthHeight(152)+"px auto");
        $('.bg5').css('background-position-x', this.calcSizeWidthHeight(264)+"px");
        $('.bg5').css('background-position-y', this.calcSizeWidthHeight(21)+"px");

        $('.bg6').css('background-size', this.calcSizeWidthHeight(138)+"px auto");
        $('.bg6').css('background-position-x', this.calcSizeWidthHeight(277)+"px");
        $('.bg6').css('background-position-y', this.calcSizeWidthHeight(33)+"px");

        $('.loginFormTitle').css('width', this.calcSizeWidthHeight(50)+"px");
        $('.loginFormTitle').css('height', this.calcSizeWidthHeight(15)+"px");
        $('.loginFormTitle').css('fontSize', this.calcSizeWidthHeight(20)+"px");
        $('.loginFormTitle').css('marginTop', this.calcSizeWidthHeight(30)+"px");

        $('.loginWeixin').css('height', this.calcSizeWidthHeight(34)+"px");
        $('.loginWeixin').css('fontsize', this.calcSizeWidthHeight(20)+"px");

        $('.headBanner').css('margin-left', this.calcSizeWidthHeight(550) + 'px');
        $('.headBanner').css('width', this.calcSizeWidthHeight(750) + 'px');
        $('.headBanner').css('bottom', this.calcSizeWidthHeight(0) + 'px');
        $('.el-carousel__container').css('height', this.calcSizeWidthHeight(400)+'px');
        $('.el-carousel__item').css('height', this.calcSizeWidthHeight(400)+'px');

        $('.loginBtn').css('margin-top', this.calcSizeWidthHeight(20)+'px');
        $('.loginBtn').css('font-size', this.calcSizeWidthHeight(20)+'px');
        $('.loginBtn').css('width', this.calcSizeWidthHeight(190)+'px');
        $('.loginBtn').css('height', this.calcSizeWidthHeight(40)+'px');

        $('.weixinTitle').css('font-size', this.calcSizeWidthHeight(16)+'px');

        $('.icoLoginSucc').css('border-radius', '50%');
        $('.icoLoginSucc').css('width', this.calcSizeWidthHeight(83)+'px');
        $('.icoLoginSucc').css('height', this.calcSizeWidthHeight(83)+'px');

        $('.loginDesc').css('margin-top', this.calcSizeWidthHeight(10)+'px');
        $('.loginDesc').css('font-size', this.calcSizeWidthHeight(16)+'px');

        $('.el-carousel__container').css('height', this.calcSizeWidthHeight(400)+'px');

        // 二维码圆角
        $('.loginQrcode').css('border-radius', this.calcSizeWidthHeight(15)+'px');

    },
    styleInit2(){
      $('.reportExample').css('height', this.calcSizeWidthHeight(817)+"px");
      $('.reportExample').css('padding-right', this.calcSizeWidthHeight(257.7)+"px");
      $('.reportExample').css('padding-left', this.calcSizeWidthHeight(257.7)+"px");
      $('.reportExample').find('.descHeader').css('margin-top', this.calcSizeWidthHeight(105.46)+"px");
      $('.reportExampleDesc').css('margin-top', this.calcSizeWidthHeight(135.79)+"px");
      $('.reportExampleDescTitle').css('height', this.calcSizeWidthHeight(20)+"px");
      $('.reportExampleDescTitle').css('font-size', this.calcSizeWidthHeight(20)+"px");
      $('.reportExampleDescTitle').css('line-height', this.calcSizeWidthHeight(20)+"px");
      $('.reportExampleDescTitle').css('margin-bottom', this.calcSizeWidthHeight(26.76)+"px");

      $('.reportExampleDescItem').css('font-size', this.calcSizeWidthHeight(16)+"px");
      $('.reportExampleDescItem').css('height', this.calcSizeWidthHeight(16)+"px");
      $('.reportExampleDescItem').css('line-height', this.calcSizeWidthHeight(16)+"px");
      $('.reportExampleDescItem').css('margin-bottom', this.calcSizeWidthHeight(18)+"px");

      $('.reportExampleShowBtn').css('width', this.calcSizeWidthHeight(198)+"px");
      $('.reportExampleShowBtn').css('height', this.calcSizeWidthHeight(60)+"px");
      $('.reportExampleShowBtn').css('font-size', this.calcSizeWidthHeight(18)+"px");
      $('.reportExampleShowBtn').css('line-height', this.calcSizeWidthHeight(60)+"px");
      $('.reportExampleShowBtn').css('margin-top', this.calcSizeWidthHeight(55.5)+"px");

      $('.reportExampleDescNav').css('right', this.calcSizeWidthHeight(257.7)+"px");
      $('.reportExampleDescNav').css('top', this.calcSizeWidthHeight(82.66)+"px");

      $('.reportExampleDescNavItem').css('font-size', this.calcSizeWidthHeight(18)+"px");
      $('.reportExampleDescNavItem').css('height', this.calcSizeWidthHeight(18)+"px");
      $('.reportExampleDescNavItem').css('line-height', this.calcSizeWidthHeight(18)+"px");
      $('.reportExampleDescNavItem').css('margin-left', this.calcSizeWidthHeight(84.25)+"px");


      $('.reportExampleImgOutter').css('width', this.calcSizeWidthHeight(894)+"px");
      $('.reportExampleImgOutter').css('height', this.calcSizeWidthHeight(595)+"px");
      $('.reportExampleImgOutter').css('border-width', this.calcSizeWidthHeight(10)+"px");
      $('.reportExampleImgOutter').css('border-radius', this.calcSizeWidthHeight(20)+"px");
      $('.reportExampleImgOutter').css('right', this.calcSizeWidthHeight(257.7)+"px");
      $('.reportExampleImgOutter').css('top', this.calcSizeWidthHeight(143.12)+"px");

      $('.reportExampleImgImg').css('border-radius', this.calcSizeWidthHeight(20)+"px");

      document.styleSheets[0].addRule('.reportExampleDescNavItem.select:after', 'height:'+this.calcSizeWidthHeight(4)+"px"+' !important;');
      document.styleSheets[0].addRule('.reportExampleDescNavItem.select:after', 'bottom:'+this.calcSizeWidthHeight(-12.88)+"px"+' !important;');
    },
    styleInit3(){
      $('.userLiuyan').css('height', this.calcSizeWidthHeight(746)+"px");
      $('.userLiuyan').css('padding-left', this.calcSizeWidthHeight(258)+"px");
      $('.userLiuyan').css('padding-top', this.calcSizeWidthHeight(78)+"px");

      $('.userCommentOut').css('width', this.calcSizeWidthHeight(1029)+"px");
      $('.userCommentOut').css('height', this.calcSizeWidthHeight(307)+"px");
      $('.userCommentOut').css('margin-top', this.calcSizeWidthHeight(45)+"px");
      $('.userCommentOut').css('padding-top', this.calcSizeWidthHeight(58)+"px");
      $('.userCommentOut').css('padding-right', this.calcSizeWidthHeight(71)+"px");
      $('.userCommentOut').css('padding-bottom', this.calcSizeWidthHeight(0)+"px");
      $('.userCommentOut').css('padding-left', this.calcSizeWidthHeight(56)+"px");

      $('.userCommentPhone').css('height', this.calcSizeWidthHeight(22)+"px");
      $('.userCommentPhone').css('font-size', this.calcSizeWidthHeight(22)+"px");
      $('.userCommentPhone').css('line-height', this.calcSizeWidthHeight(22)+"px");

      $('.userCommentDate').css('height', this.calcSizeWidthHeight(16)+"px");
      $('.userCommentPhone').css('line-height', this.calcSizeWidthHeight(16)+"px");
      $('.userCommentPhone').css('font-size', this.calcSizeWidthHeight(16)+"px");
      $('.userCommentPhone').css('margin-top', this.calcSizeWidthHeight(28)+"px");

      $('.userComment').css('height', this.calcSizeWidthHeight(28)+"px");
      $('.userComment').css('font-size', this.calcSizeWidthHeight(16)+"px");
      $('.userComment').css('line-height', this.calcSizeWidthHeight(28)+"px");
      $('.userComment').css('margin-top', this.calcSizeWidthHeight(25)+"px");
    },
    styleInit4(){
      $('.paperDescListOutter').css('min-height', this.calcSizeWidthHeight(660.1)+"px");
      $('.paperDescListOutter').css('padding-left', this.calcSizeWidthHeight(257.7)+"px");
      $('.paperDescListOutter').css('padding-top', this.calcSizeWidthHeight(79)+"px");
      $('.paperDescListOutter').css('padding-bottom', this.calcSizeWidthHeight(79)+"px");

      $('.paperDescList').css('width', this.calcSizeWidthHeight(1388)+"px");
      $('.paperDescList').css('margin-top', this.calcSizeWidthHeight(19.82)+"px");

      $('.paperDescListTitleIcon').css('width', this.calcSizeWidthHeight(32)+"px");
      $('.paperDescListTitleIcon').css('height', this.calcSizeWidthHeight(32)+"px");
      $('.paperDescListTitleIcon').css('top', this.calcSizeWidthHeight(14)+"px");
      $('.paperDescListTitleIcon').css('right', this.calcSizeWidthHeight(24)+"px");

      $('.paperDescListTitleIcon').find('.shou1').css('width', this.calcSizeWidthHeight(16)+"px");
      $('.paperDescListTitleIcon').find('.shou1').css('height', this.calcSizeWidthHeight(17)+"px");
      $('.paperDescListTitleIcon').find('.shou1').css('left', this.calcSizeWidthHeight(8)+"px");
      $('.paperDescListTitleIcon').find('.shou1').css('top', this.calcSizeWidthHeight(8)+"px");

      $('.paperDescListTitleIcon').find('.shou2').css('width', this.calcSizeWidthHeight(16)+"px");
      $('.paperDescListTitleIcon').find('.shou2').css('height', this.calcSizeWidthHeight(17)+"px");
      $('.paperDescListTitleIcon').find('.shou2').css('left', this.calcSizeWidthHeight(8)+"px");
      $('.paperDescListTitleIcon').find('.shou2').css('top', this.calcSizeWidthHeight(8)+"px");

      $('.paperDescListTitleIcon').find('.zhan1').css('width', this.calcSizeWidthHeight(16)+"px");
      $('.paperDescListTitleIcon').find('.zhan1').css('height', this.calcSizeWidthHeight(2)+"px");
      $('.paperDescListTitleIcon').find('.zhan1').css('left', this.calcSizeWidthHeight(8)+"px");
      $('.paperDescListTitleIcon').find('.zhan1').css('top', this.calcSizeWidthHeight(15)+"px");

      $('.paperDescListTitle').css('padding-left', this.calcSizeWidthHeight(29)+"px");
      $('.paperDescListTitle').css('padding-left', this.calcSizeWidthHeight(29)+"px");
      $('.paperDescListTitle').css('width', this.calcSizeWidthHeight(1388)+"px");
      $('.paperDescListTitle').css('height', this.calcSizeWidthHeight(59)+"px");
      $('.paperDescListTitle').css('line-height', this.calcSizeWidthHeight(59)+"px");
      $('.paperDescListTitle').css('font-size', this.calcSizeWidthHeight(16)+"px");

      $('.paperDescListContent').css('font-size', this.calcSizeWidthHeight(14)+"px");
      $('.paperDescListContent').css('line-height', this.calcSizeWidthHeight(31)+"px");
    },
    styleInit5(){
      $('.friendLinkOutter').css('min-height', this.calcSizeWidthHeight(785)+"px");
      $('.friendLinkOutter').css('padding-left', this.calcSizeWidthHeight(258)+"px");
      $('.friendLinkOutter').css('padding-top', this.calcSizeWidthHeight(78)+"px");
      $('.friendLinkCompany').css('width', this.calcSizeWidthHeight(1388)+"px");
      $('.friendLinkCompany').css('height', this.calcSizeWidthHeight(357)+"px");
      $('.friendLinkCompany').css('margin-top', this.calcSizeWidthHeight(14)+"px");
      $('.friendLinkCompanyItem').css('width', this.calcSizeWidthHeight(198)+"px");
      $('.friendLinkCompanyItem').css('height', this.calcSizeWidthHeight(119)+"px");
      $('.school_logo1').find('img').css('width', this.calcSizeWidthHeight(147)+"px");
      $('.school_logo1').find('img').css('height', this.calcSizeWidthHeight(42)+"px");
      $('.school_logo1').find('img').css('margin-left', this.calcSizeWidthHeight(27)+"px");
      $('.school_logo1').find('img').css('margin-top', this.calcSizeWidthHeight(40)+"px");
      $('.school_logo2').find('img').css('width', this.calcSizeWidthHeight(157)+"px");
      $('.school_logo2').find('img').css('height', this.calcSizeWidthHeight(33)+"px");
      $('.school_logo2').find('img').css('margin-left', this.calcSizeWidthHeight(21)+"px");
      $('.school_logo2').find('img').css('margin-top', this.calcSizeWidthHeight(44)+"px");
      $('.school_logo3').find('img').css('width', this.calcSizeWidthHeight(164)+"px");
      $('.school_logo3').find('img').css('height', this.calcSizeWidthHeight(52)+"px");
      $('.school_logo3').find('img').css('margin-left', this.calcSizeWidthHeight(17)+"px");
      $('.school_logo3').find('img').css('margin-top', this.calcSizeWidthHeight(38)+"px");
      $('.school_logo4').find('img').css('width', this.calcSizeWidthHeight(165)+"px");
      $('.school_logo4').find('img').css('height', this.calcSizeWidthHeight(34)+"px");
      $('.school_logo4').find('img').css('margin-left', this.calcSizeWidthHeight(20)+"px");
      $('.school_logo4').find('img').css('margin-top', this.calcSizeWidthHeight(44)+"px");
      $('.school_logo5').find('img').css('width', this.calcSizeWidthHeight(182)+"px");
      $('.school_logo5').find('img').css('height', this.calcSizeWidthHeight(49)+"px");
      $('.school_logo5').find('img').css('margin-left', this.calcSizeWidthHeight(6)+"px");
      $('.school_logo5').find('img').css('margin-top', this.calcSizeWidthHeight(36)+"px");
      $('.school_logo6').find('img').css('width', this.calcSizeWidthHeight(175)+"px");
      $('.school_logo6').find('img').css('height', this.calcSizeWidthHeight(42)+"px");
      $('.school_logo6').find('img').css('margin-left', this.calcSizeWidthHeight(13)+"px");
      $('.school_logo6').find('img').css('margin-top', this.calcSizeWidthHeight(36)+"px");
      $('.school_logo7').find('img').css('width', this.calcSizeWidthHeight(147)+"px");
      $('.school_logo7').find('img').css('height', this.calcSizeWidthHeight(40)+"px");
      $('.school_logo7').find('img').css('margin-left', this.calcSizeWidthHeight(19)+"px");
      $('.school_logo7').find('img').css('margin-top', this.calcSizeWidthHeight(36)+"px");
      $('.school_logo8').find('img').css('width', this.calcSizeWidthHeight(157)+"px");
      $('.school_logo8').find('img').css('height', this.calcSizeWidthHeight(55)+"px");
      $('.school_logo8').find('img').css('margin-left', this.calcSizeWidthHeight(18)+"px");
      $('.school_logo8').find('img').css('margin-top', this.calcSizeWidthHeight(37)+"px");
      $('.school_logo9').find('img').css('width', this.calcSizeWidthHeight(157)+"px");
      $('.school_logo9').find('img').css('height', this.calcSizeWidthHeight(44)+"px");
      $('.school_logo9').find('img').css('margin-left', this.calcSizeWidthHeight(19)+"px");
      $('.school_logo9').find('img').css('margin-top', this.calcSizeWidthHeight(39)+"px");
      $('.school_logo10').find('img').css('width', this.calcSizeWidthHeight(174)+"px");
      $('.school_logo10').find('img').css('height', this.calcSizeWidthHeight(51)+"px");
      $('.school_logo10').find('img').css('margin-left', this.calcSizeWidthHeight(12)+"px");
      $('.school_logo10').find('img').css('margin-top', this.calcSizeWidthHeight(37)+"px");
      $('.school_logo11').find('img').css('width', this.calcSizeWidthHeight(135)+"px");
      $('.school_logo11').find('img').css('height', this.calcSizeWidthHeight(39)+"px");
      $('.school_logo11').find('img').css('margin-left', this.calcSizeWidthHeight(35)+"px");
      $('.school_logo11').find('img').css('margin-top', this.calcSizeWidthHeight(44)+"px");
      $('.school_logo12').find('img').css('width', this.calcSizeWidthHeight(145)+"px");
      $('.school_logo12').find('img').css('height', this.calcSizeWidthHeight(40)+"px");
      $('.school_logo12').find('img').css('margin-left', this.calcSizeWidthHeight(22)+"px");
      $('.school_logo12').find('img').css('margin-top', this.calcSizeWidthHeight(40)+"px");
      $('.school_logo13').find('img').css('width', this.calcSizeWidthHeight(161)+"px");
      $('.school_logo13').find('img').css('height', this.calcSizeWidthHeight(38)+"px");
      $('.school_logo13').find('img').css('margin-left', this.calcSizeWidthHeight(17)+"px");
      $('.school_logo13').find('img').css('margin-top', this.calcSizeWidthHeight(42)+"px");
      $('.school_logo14').find('img').css('width', this.calcSizeWidthHeight(146)+"px");
      $('.school_logo14').find('img').css('height', this.calcSizeWidthHeight(49)+"px");
      $('.school_logo14').find('img').css('margin-left', this.calcSizeWidthHeight(25)+"px");
      $('.school_logo14').find('img').css('margin-top', this.calcSizeWidthHeight(37)+"px");
      $('.school_logo15').find('img').css('width', this.calcSizeWidthHeight(170)+"px");
      $('.school_logo15').find('img').css('height', this.calcSizeWidthHeight(50)+"px");
      $('.school_logo15').find('img').css('margin-left', this.calcSizeWidthHeight(19)+"px");
      $('.school_logo15').find('img').css('margin-top', this.calcSizeWidthHeight(39)+"px");
      $('.school_logo16').find('img').css('width', this.calcSizeWidthHeight(114)+"px");
      $('.school_logo16').find('img').css('height', this.calcSizeWidthHeight(47)+"px");
      $('.school_logo16').find('img').css('margin-left', this.calcSizeWidthHeight(41)+"px");
      $('.school_logo16').find('img').css('margin-top', this.calcSizeWidthHeight(34)+"px");
      $('.school_logo17').find('img').css('width', this.calcSizeWidthHeight(117)+"px");
      $('.school_logo17').find('img').css('height', this.calcSizeWidthHeight(43)+"px");
      $('.school_logo17').find('img').css('margin-left', this.calcSizeWidthHeight(41)+"px");
      $('.school_logo17').find('img').css('margin-top', this.calcSizeWidthHeight(34)+"px");
      $('.school_logo18').find('img').css('width', this.calcSizeWidthHeight(143)+"px");
      $('.school_logo18').find('img').css('height', this.calcSizeWidthHeight(43)+"px");
      $('.school_logo18').find('img').css('margin-left', this.calcSizeWidthHeight(29)+"px");
      $('.school_logo18').find('img').css('margin-top', this.calcSizeWidthHeight(34)+"px");
      $('.school_logo19').find('img').css('width', this.calcSizeWidthHeight(156)+"px");
      $('.school_logo19').find('img').css('height', this.calcSizeWidthHeight(48)+"px");
      $('.school_logo19').find('img').css('margin-left', this.calcSizeWidthHeight(17)+"px");
      $('.school_logo19').find('img').css('margin-top', this.calcSizeWidthHeight(34)+"px");
      $('.school_logo20').find('img').css('width', this.calcSizeWidthHeight(174)+"px");
      $('.school_logo20').find('img').css('height', this.calcSizeWidthHeight(47)+"px");
      $('.school_logo20').find('img').css('margin-left', this.calcSizeWidthHeight(13)+"px");
      $('.school_logo20').find('img').css('margin-top', this.calcSizeWidthHeight(34)+"px");
      $('.school_logo21').find('img').css('width', this.calcSizeWidthHeight(165)+"px");
      $('.school_logo21').find('img').css('height', this.calcSizeWidthHeight(47)+"px");
      $('.school_logo21').find('img').css('margin-left', this.calcSizeWidthHeight(15)+"px");
      $('.school_logo21').find('img').css('margin-top', this.calcSizeWidthHeight(34)+"px");
      $('.friendLink2').css('margin-top', this.calcSizeWidthHeight(82)+"px");
      $('.friendLink2List').css('margin-top', this.calcSizeWidthHeight(4.569999999999993)+"px");
      $('.friendLink2List').css('width', this.calcSizeWidthHeight(1388)+"px");
      $('.friendLink2List').find('a').css('height', this.calcSizeWidthHeight(16)+"px");
      $('.friendLink2List').find('a').css('font-size', this.calcSizeWidthHeight(16)+"px");
      $('.friendLink2List').find('a').css('line-height', this.calcSizeWidthHeight(38)+"px");
      $('.friendLink2List').find('a').css('margin-right', this.calcSizeWidthHeight(28)+"px");
    },
    styleInit6(){
      $('.goCheckOutter').css('height', this.calcSizeWidthHeight(242)+"px");
      $('.goCheckDesc').css('height', this.calcSizeWidthHeight(41)+"px");
      $('.goCheckDesc').css('font-size', this.calcSizeWidthHeight(41)+"px");
      $('.goCheckDesc').css('line-height', this.calcSizeWidthHeight(41)+"px");
      $('.goCheckDesc').css('margin-top', this.calcSizeWidthHeight(69)+"px");
      $('.goCheckBtn').css('width', this.calcSizeWidthHeight(198)+"px");
      $('.goCheckBtn').css('height', this.calcSizeWidthHeight(59)+"px");
      $('.goCheckBtn').css('line-height', this.calcSizeWidthHeight(59)+"px");
      $('.goCheckBtn').css('margin', this.calcSizeWidthHeight(42)+"px "+" auto 0px");
      $('.goCheckBtn').css('font-size', this.calcSizeWidthHeight(18)+"px");
      $('.jifenhuodongMaskImg').css('margin-left', this.calcSizeWidthHeight(-460)+"px");
      $('.jifenhuodongMaskImg').css('margin-top', this.calcSizeWidthHeight(-290)+"px");
      $('.jifenhuodongMaskImg').css('width', this.calcSizeWidthHeight(920)+"px");
      $('.jifenhuodongMaskImg').css('height', this.calcSizeWidthHeight(580)+"px");
      $('.closejifen').css('margin-left', this.calcSizeWidthHeight(418)+"px");
      $('.closejifen').css('margin-top', this.calcSizeWidthHeight(-270)+"px");
      $('.closejifen').css('width', this.calcSizeWidthHeight(22)+"px");
      $('.closejifen').css('height', this.calcSizeWidthHeight(23)+"px");

      $('.jifenDescCon').css('margin-top', this.calcSizeWidthHeight(5)+"px");
      $('.jifenDescCon').css('height', this.calcSizeWidthHeight(285)+"px");
      $('.jifenDescCon').css('width', this.calcSizeWidthHeight(710)+"px");
      $('.jifenDescCon').css('margin-left', this.calcSizeWidthHeight(-448)+"px");

      $('.jifenDescCon').find('div').css('font-size', this.calcSizeWidthHeight(12)+"px");
      $('.jifenDescCon').find('div').css('padding-left', this.calcSizeWidthHeight(101)+"px");
      $('.jifenDescCon').find('div').css('margin-bottom', this.calcSizeWidthHeight(10)+"px");
      $('.jifenDescCon').find('div').css('line-height', this.calcSizeWidthHeight(20)+"px");

      $('.jifenDescCon').find('div').find('p').css('width', this.calcSizeWidthHeight(8)+"px");
      $('.jifenDescCon').find('div').find('p').css('height', this.calcSizeWidthHeight(8)+"px");
      $('.jifenDescCon').find('div').find('p').css('left', this.calcSizeWidthHeight(84)+"px");
      $('.jifenDescCon').find('div').find('p').css('top', this.calcSizeWidthHeight(6)+"px");
    },
    styleInit7(){
      $('.avatorUrl').css('width', this.calcSizeWidthHeight(128)+"px");
      $('.avatorUrl').css('margin', this.calcSizeWidthHeight(52)+"px auto 0px");

      $('.nickName').css('line-height', this.calcSizeWidthHeight(16)+"px");
      $('.nickName').css('height', this.calcSizeWidthHeight(16)+"px");
      $('.nickName').css('font-size', this.calcSizeWidthHeight(16)+"px");
      $('.nickName').css('margin-top', this.calcSizeWidthHeight(22)+"px");

      $('.logined').find('a').css('width', this.calcSizeWidthHeight(325)+"px");
      $('.logined').find('a').css('height', this.calcSizeWidthHeight(46)+"px");
      $('.logined').find('a').css('line-height', this.calcSizeWidthHeight(46)+"px");
      $('.logined').find('a').css('border-radius', this.calcSizeWidthHeight(3)+"px");
      $('.logined').find('a').css('font-size', this.calcSizeWidthHeight(16)+"px");
      $('.checkcenter').css('margin', this.calcSizeWidthHeight(38)+"px auto 0px");
      $('.viewReport,.logout').css('margin', this.calcSizeWidthHeight(14)+"px auto 0px");
    },
    calcSizeWidthHeight(num) {
      return document.body.clientWidth*(num/1903);
    },
    expandDesc(index) {
      var obj = $('.paperDescListContent').eq(index);
      if(obj.hasClass('select')){
          obj.parent().find('.paperDescListTitle').removeClass('select');
          obj.removeClass('select');

          $('.paperDescListContent').css('padding-top', "0px");
          $('.paperDescListContent').css('padding-right', "0px");
          $('.paperDescListContent').css('padding-bottom', "0px");
          $('.paperDescListContent').css('padding-left', "0px");
          $('.paperDescListContent').css('height', "0px");
          $('.paperDescListContent').css('max-height', "0px");

          setTimeout(function(){
            obj.parent().find('.zhan1').hide();
            obj.parent().find('.shou1').hide();
            obj.parent().find('.shou2').show();
          }, 200);
      }else{
        $('.paperDescListTitle').removeClass('select');
        $('.paperDescListContent').removeClass('select');
        setTimeout(function(){
            obj.parent().find('.shou1').hide();
            obj.parent().find('.shou2').hide();
            obj.parent().find('.zhan1').show();
        }, 200);
        obj.parent().find('.paperDescListTitle').addClass('select');
        obj.addClass('select');

        $('.paperDescListContent.select').css('padding-top', this.calcSizeWidthHeight(20.7)+"px");
        $('.paperDescListContent.select').css('padding-right', this.calcSizeWidthHeight(34.69)+"px");
        $('.paperDescListContent.select').css('padding-bottom', this.calcSizeWidthHeight(0)+"px");
        $('.paperDescListContent.select').css('padding-left', this.calcSizeWidthHeight(34.69)+"px");
        $('.paperDescListContent.select').css('height', "auto");
        $('.paperDescListContent.select').css('max-height', this.calcSizeWidthHeight(1200)+"px");

        setTimeout(function(){obj.height(obj.height());}, 500);
      }
    },
    toAvator(index) {
      clearInterval(this.epopInterVal);
      this.epopInterVal = null;
      this.aindex = index;
      this.phone = this.fwxz[this.aindex].phone;
      this.date = this.fwxz[this.aindex].date;
      this.text = this.fwxz[this.aindex].text;
      this.epopAvator();
    },
    epopAvator() {
      var that = this;
      clearInterval(this.epopInterVal);
      this.epopInterVal = null;
      this.epopInterVal = setInterval(function(){
        that.phone = that.fwxz[that.aindex].phone;
        that.date = that.fwxz[that.aindex].date;
        that.text = that.fwxz[that.aindex].text;
        if(that.aindex >= 6) that.aindex = -1;
        ++that.aindex;
      }, 5000);
    },
    goPage(newpage) {
      location.href = '/' + newpage;
    },
    focusCarousel() {
      $('.el-carousel__container').css('height', this.calcSizeWidthHeight(400)+'px');
      $('.el-carousel__item').css('height', this.calcSizeWidthHeight(400)+'px');
    }
  },
  mounted() {
    this.pageShow = true;
    window.onresize = () => {
      return (() => {
        this.styleInit();
        this.styleInit2();
        this.styleInit3();
        this.styleInit4();
        this.styleInit5();
        this.styleInit6();
        this.styleInit7();
        this.$refs.headercom.styleInit();
        this.$refs.footercom.styleInit();
      })()
    }
    this.styleInit();
    this.styleInit2();
    this.styleInit3();
    this.styleInit4();
    this.styleInit5();
    this.styleInit6();
    this.styleInit7();
    this.epopAvator();
    if (this.$store.state.user.userstr) {
      this.userLoginStatus = true;
      this.userLevel = this.$store.state.user.userlevel;
    }

    this.getLoginQrcode();
  },
  created() {
     // 显示首页VIP横幅
    let expire = this.$Cookies.get("vip_banner_expire");
    let now = new Date().getTime();
    this.isShowVipBanner = now < expire || !!isMobile() ? false : true;
  },
};
</script>

<style scoped>
/* 微信扫码登录 begin */
.box_container {
  display: flex;
}
.qrcode_box {
  margin: 0px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
}
.qrcode_box_right {
  margin: 0px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 200px;
}
.qrcode_pic {
  width: 180px;
  height: 180px;
}
.guider_pic {
  width: 117px;
  height: 210px;
}
.error_box {
  background: #ffffff;
  position: absolute;
  left: 28%;
  top: 30%;
  width: 180px;
  height: 180px;
  display: flex;
  color: white;
  font-size: 13pt;
  font-weight: bold;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0.9;
}
.error_box img {
  width: 45px;
  height: 45px;
  cursor: pointer;
}
.tip1 {
  color: #000000;
}
.tip2 {
  color: red;
}
.login_dialog {
  margin-top: 10vh;
}
.desc_top {
  color: #000000;
  font-family: PingFangSC-Semibold;
  font-size: 16pt;
  font-weight: bold;
}
.desc_bottom {
  bottom: 45px;
  font-family: PingFangSC-Semibold;
  font-size: 12pt;
  display: flex;
  align-items: center;
}
.desc_bottom img {
  width: 30px;
  margin-right: 5px;
}
/* 微信扫码登录 end */

/* 动态过渡显示 begin */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
/* 动态过渡显示 end */

/* 首页VIP购买横幅 begin */
.ind_vip_banner {
  width: 100%;
  height: 300px;
  display: inline-flex;
  position: fixed;
  top: 75%;
  left: 0;
  z-index: 1001;
  border-radius: 0px 6px 6px 0px;
  cursor: pointer;
  justify-content: center;
}
.vip_banner{
  height: 300px;
}
.ico_close {
  width: 33px;
  height: 33px;
  margin-left: -35px;
}
.loginForm{
	width: 426px;
	height: 495px;
	/* background: #FFFFFF; */
	/* box-shadow: 0px 0px 27px 0px rgba(80, 92, 85, 0.27); */
	box-sizing: border-box;
	position: absolute;
}
/* 首页VIP购买横幅 end */
/* 首页banner内按钮 begin */
/* 首页banner内按钮 end */
.loginFormQrcodeTitle{
	width: 100%;
	line-height: 16px;
	font-size: 16px;
	font-family: PingFangSC-Regular,微软雅黑;
	color: #222222;
	margin-top: 27px;
}
.qrcodenew{
	width: 255px;
	height: 254px;
	margin:29px auto 0px;
	background: #FFFFFF;
	border: 1px solid #30A263;
	border-radius: 10px;
	box-sizing: border-box;
	padding: 18px;
}
.qrcodenewDesc{
	position: relative;
	width: 100%;
	line-height: 14px;
	font-size: 14px;
	font-family: PingFangSC-Regular,微软雅黑;
	color: #222222;
	text-align:left;
	margin-top: 39px;
	padding-left: 155px;
	box-sizing: border-box;
}
.weixinIcon{
	position: absolute;
	display: block;
	left: 117px;
	top: -8px;
	width: 30px;
	height: 30px;
}
.qrcodenew img{
	width: 100%;
	height: 100%;
}

/* 新的部分 */
.descOutter{
	width: 100%;
	height: 1090px;
	background-image: url(../../../static/img/desc_bg.png);
	background-size: 100%;
	background-repeat:no-repeat;
	box-sizing: border-box;
  overflow: hidden;
}
.descInner{
	width: 1388px;
	margin:0 auto;
	height: auto;
	overflow: hidden;
  margin-top: 78.9px;
}
.descHeader{
	width: 100%;
	height: 64.43px;
	position: relative;
}
.descHeaderImg{
	width: 35px;
	height: 35px;
	position: absolute;
	left: 0px;
	top: 0px;
}
.descHeaderDesc{
	width: 100%;
	line-height: 36px;
	font-size: 36px;
	font-weight: 500;
	color: #03160F;
  font-family: PingFangSC-Semibold,微软雅黑;
	text-align: left;
	padding-left: 44.599999999999994px;
	box-sizing: border-box;
}
.descHeaderDesc2{
	width: 100%;
	line-height: 16px;
	font-size: 16px;
	font-family: PingFangSC-Regular,微软雅黑;
	font-weight: 400;
	color: #7D8380;
	text-align: left;
	padding-left: 44.599999999999994px;
	box-sizing: border-box;
	margin-top: 10.9px;
}
.descContent{
	overflow: hidden;
}
.descContent2{
  margin-top: 39.65px;
}
.descContentItem{
	float: left;
	width: 265.33px;
	height: 132.71px;
	margin-right: 15px;
	margin-top: 93.17px;
	box-sizing: border-box;
}
.descContentItemend{
	margin-right: 0px !important;
}
.greenBottom{
	border-bottom:1px solid #30A263;
}
.orangeBottom{
	border-bottom:1px solid #FF7900;
}

.descContentItemTitle{
	width: 100%;
	height: 45.59px;
	line-height: 45.59px;
	font-size: 59px;
	font-family: PingFangSC-Semibold,微软雅黑;
	color: #031610;
	text-align: center;
}
.descContentItemTitleSpan{
	font-size: 20px;
	font-family: PingFangSC-Semibold,微软雅黑;
	color: #031610;
}
.descContentItemDesc{
	width: 100%;
	line-height: 16px;
	font-size: 16px;
	font-family: 微软雅黑;
	color: #7D8380;
	text-align: center;
	margin-top: 16.85px;
}
.index_check_btn{
  font-family: AlibabaPuHuiTi-Medium65,微软雅黑;
}
.descInner2{
  margin-top: 99.2px !important;
}
.descContentLsit{
  width: 446px;
  height: 199px;
  box-shadow: 0px 0px 7px 0px rgba(47, 47, 47, 0.1);
  box-sizing: border-box;
  padding-top: 53.52px;
  padding-left: 40.64px;
  padding-right: 35.68px;
  float: left;
  margin-right: 24.78px;
}
.descContentLsit.bg3,.descContentLsit.bg6{
  margin-right: 0px !important;
}
.descContentLsit.bg4,.descContentLsit.bg5,.descContentLsit.bg6{
  margin-top: 26.46px !important;
}
.descContentLsitTitle{
  width: 100%;
  text-align: left;
  line-height: 20px;
  height: 20px;
  font-size: 20px;
  font-family: PingFangSC-Medium,微软雅黑;
  font-weight: 500;
  color: #FFFFFF;
}
.descContentLsitDesc{
  width: 100%;
  font-size: 16px;
  font-family: PingFangSC-Regular,微软雅黑;
  text-align: justify;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 25px;
  margin-top: 25.77px;
}
.bg1{
  background-color:#30A263;
  background-image:url(../../../static/img/newicon1.png);
  background-size:129px auto;
  background-repeat:no-repeat;
  background-position-x:309px;
  background-position-y:27px;
}
.bg2{
  background-color:#4F70F9;
  background-image:url(../../../static/img/newicon2.png);
  background-size:184px auto;
  background-repeat:no-repeat;
  background-position-x:237px;
  background-position-y:31px;
}
.bg3{
  background-color:#F08A3F;
  background-image:url(../../../static/img/newicon3.png);
  background-size:152px auto;
  background-repeat:no-repeat;
  background-position-x:269px;
  background-position-y:37px;
}
.bg4{
  background-color:#EE614E;
  background-image:url(../../../static/img/newicon4.png);
  background-size:126px auto;
  background-repeat:no-repeat;
  background-position-x:306px;
  background-position-y:20px;
}
.bg5{
  background-color:#00B0C5;
  background-image:url(../../../static/img/newicon5.png);
  background-size:152px auto;
  background-repeat:no-repeat;
  background-position-x:264px;
  background-position-y:21px;
}
.bg6{
  background-color:#259F92;
  background-image:url(../../../static/img/newicon6.png);
  background-size:138px auto;
  background-repeat:no-repeat;
  background-position-x:277px;
  background-position-y:33px;
}
/* start end1 */



.reportExample{
  width: 100%;
  height: 817px;
  background: #FFFFFF;
  box-sizing: border-box;
  overflow:hidden;
  background: #FFFFFF;
  padding: 0px 257.7px 0px 257.7px;
  position: relative;
}
.reportExample .descHeaderDesc{
  width: auto;
}
.reportExample .descHeader{
  margin-top: 105.46px;
  float: left;
}
.reportExampleDesc{
  float: left;
  margin-top: 135.79px;
  text-align: left;
}
.reportExampleDescTitle{
  height: 20px;
  font-size: 20px;
  font-family: PingFangSC-Semibold,微软雅黑;
  color: #03160F;
  line-height: 20px;
  margin-bottom:26.76px;
}
.reportExampleDescItem{
  font-size: 16px;
  height: 16px;
  line-height: 16px;
  font-family: PingFangSC-Regular,微软雅黑;
  font-weight: 400;
  color: #7D8380;
  margin-bottom:18px;
}
.reportExampleShowBtn{
  width: 198px;
  height: 60px;
  background: #30A263;
  font-size: 18px;
  font-family: PingFangSC-Regular,微软雅黑;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 60px;
  text-align: center;
  margin-top: 55.5px;
  cursor: pointer;
}
.reportExampleDescNav{
  float: right;
  position: absolute;
  right: 257.7px;
  top: 82.66px;
}
.reportExampleDescNavItem{
  float: left;
  font-size: 18px;
  height: 18px;
  line-height: 18px;
  margin-left: 84.25px;
  font-family: PingFangSC-Regular,微软雅黑;
  font-weight: 400;
  color: #03160F;
  cursor: pointer;
}
.reportExampleDescNavItem.select{
  color:#30A263;
  position: relative;
}
.reportExampleDescNavItem.select:after{
  content: "";
  width: 100%;
  height: 4px;
  background: #30A263;
  left: 0px;
  bottom: -12.88px;
  position: absolute;
}
.reportExampleImgOutter{
  float: right;
  width: 894px;
  height: 595px;
  background: #F5F5F5;
  border: 10px solid #DBEEE4;
  border-radius: 20px;
  position: absolute;
  right: 257.7px;
  top: 143.12px;
  overflow-y: auto;
  box-sizing: border-box;
}
.reportExampleImgImg{
  width: 100%;
  height: auto;
  border-radius: 20px;
}

/* start end2 */

.userLiuyan{
  width: 100%;
  height: 746px;
  background: #FCFBFC;
  box-sizing: border-box;
  background-image: url(../../../static/img/bg2.jpg);
  background-size: 100%;
  background-repeat:no-repeat;
  padding-left: 258px;
  padding-top: 78px;
}
.userCommentOut{
  width: 1029px;
  height: 307px;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px 0px rgba(80, 92, 85, 0.16);
  margin-top: 45px;
  box-sizing: border-box;
  padding: 58px 71px 0px 56px;
  text-align: justify;
}
.userCommentPhone{
  height: 22px;
  font-size: 22px;
  font-family: PingFangSC-Semibold,微软雅黑;
  color: #03160F;
  line-height: 22px;
}
.userCommentDate{
  height: 16px;
  font-size: 16px;
  font-family: PingFangSC-Regular,微软雅黑;
  font-weight: 400;
  color: #7D8380;
  line-height: 16px;
  margin-top: 28px;
}
.userComment{
  height: 28px;
  font-size: 16px;
  font-family: 微软雅黑;
  font-weight: 400;
  color: #03160F;
  line-height: 28px;
  margin-top: 25px;
}
.userAvatorList{
  margin-top: 51px;
}
.userAvatorListImg{
  float: left;
  width: 119px;
  height: 119px;
  margin-right: 33px;
  margin-left: 0px;
  cursor: pointer;
}
.userAvatorListImg.select{
  width: 146px;
  height: 146px;
  background: #FFFFFF;
  box-sizing: border-box;
  border: 4px solid #FDBE11;
  position:relative;
  top: -14px;
}
.userAvatorListImg.select.userAvatorListImgInner{
  margin-right: 19px;
  margin-left: -14px;
}

.userAvatorListImg img{
  width: 100%;
  height: 100%;
}
.userAvatorListImgEnd{
  margin-right: 0px !important;
}
.hide{
  display: none;
}
/* start end3 */

.paperDescListOutter{
  width: 100%;
  min-height: 660.1px;
  background:#FFFFFF;
  box-sizing: border-box;
  padding-left: 257.7px;
  padding-top: 79px;
  padding-bottom: 79px;
}
.paperDescListFirst{
  margin-top: 0px !important;
}
.paperDescList{
  width: 1388px;
  height: auto;
  overflow: hidden;
  box-sizing: border-box;
  text-align: justify;
  margin-top: 19.82px;
}
.paperDescListTitle.select,.paperDescListTitle:hover{
  background: #30A263;
  color: #FFFFFF;
}
.paperDescListTitle.select,.paperDescListTitle:hover .shou2{
  display: none;
}
.paperDescListTitle.select,.paperDescListTitle:hover .shou1{
  display: block;
}
.paperDescListTitleIcon{
  width: 32px;
  height: 32px;
  background: #FFFFFF;
  position:absolute;
  top:14px;
  right:24px;
}
.paperDescListTitleIcon .shou1,.paperDescListTitleIcon .shou2{
  width: 16px;
  height: 17px;
  position:absolute;
  left: 8px;
  top: 8px;
}
.paperDescListTitleIcon .zhan1{
  width: 16px;
  height: 2px;
  position:absolute;
  left: 8px;
  top: 15px;

}
.paperDescListTitle{
  position:relative;
  cursor: pointer;
  width: 100%;
  padding-left: 29px;
  box-sizing: border-box;
  width: 1388px;
  height: 59px;
  line-height: 59px;
  background: #F7F7F7;
  font-size: 16px;
  font-family: PingFangSC-Regular,微软雅黑;
  font-weight: 400;
  color: #03160F;
}
.paperDescListContent{
  height: 0px;
  max-height: 0px;
  font-size: 14px;
  font-family: PingFangSC-Regular,微软雅黑;
  font-weight: 400;
  color: #03160F;
  line-height: 31px;
  box-sizing: border-box;
}
.paperDescListContent.select{
  padding: 20.7px 34.69px 0px 34.69px;
  height: auto;
}
.dh{
  -webkit-transition: all .5s ease-in-out;
  -moz-transition: all .5s ease-in-out;
  -o-transition: all .5s ease-in-out;
  transition: all .5s ease-in-out;
}
/* start end4 */


.friendLinkOutter{
  width: 100%;
  min-height: 785px;
  box-sizing: border-box;
  background-image: url(../../../static/img/bg3.png);
  background-size: 100%;
  background-repeat:no-repeat;
  padding-left: 258px;
  padding-top: 78px;
}
.friendLinkCompany{
  width: 1388px;
  height: 357px;
  background: #FFFFFF;
  margin-top: 14px;
  box-shadow: 0px 0px 27px 0px rgba(80, 92, 85, 0.07);
  overflow: hidden;
}
.friendLinkCompanyItem{
  float: left;
  width: 198px;
  height:119px;
  box-sizing: border-box;
  overflow: hidden;
  border-right: 1px solid #F2F2F2;
  border-bottom: 1px solid #F2F2F2;
}
.friendLinkCompanyItem img{
  float: left;
}
.school_logo1 img{
  width: 147px;
  height: 42px;
  margin-left: 27px;
  margin-top: 40px;
}
.school_logo2 img{
  width: 157px;
  height: 33px;
  margin-left: 21px;
  margin-top: 44px;
}
.school_logo3 img{
  width: 164px;
  height: 52px;
  margin-left: 17px;
  margin-top: 38px;
}
.school_logo4 img{
  width: 165px;
  height: 34px;
  margin-left: 20px;
  margin-top: 44px;
}
.school_logo5 img{
  width: 182px;
  height: 49px;
  margin-left: 6px;
  margin-top: 36px;
}
.school_logo6 img{
  width: 175px;
  height: 42px;
  margin-left: 13px;
  margin-top: 36px;
}
.school_logo7 img{
  width: 147px;
  height: 40px;
  margin-left: 19px;
  margin-top: 36px;
}
.school_logo8 img{
  width: 157px;
  height: 55px;
  margin-left: 18px;
  margin-top: 37px;
}
.school_logo9 img{
  width: 157px;
  height: 44px;
  margin-left: 19px;
  margin-top: 39px;
}
.school_logo10 img{
  width: 174px;
  height: 51px;
  margin-left: 12px;
  margin-top: 37px;
}
.school_logo11 img{
  width: 135px;
  height: 39px;
  margin-left: 35px;
  margin-top: 44px;
}
.school_logo12 img{
  width: 145px;
  height: 40px;
  margin-left: 22px;
  margin-top: 40px;
}
.school_logo13 img{
  width: 161px;
  height: 38px;
  margin-left: 17px;
  margin-top: 42px;
}
.school_logo14 img{
  width: 146px;
  height: 49px;
  margin-left: 25px;
  margin-top: 37px;
}
.school_logo15 img{
  width: 170px;
  height: 50px;
  margin-left: 19px;
  margin-top: 39px;
}
.school_logo16 img{
  width: 114px;
  height: 47px;
  margin-left: 41px;
  margin-top: 34px;
}
.school_logo17 img{
  width: 117px;
  height: 43px;
  margin-left: 41px;
  margin-top: 34px;
}
.school_logo18 img{
  width: 143px;
  height: 43px;
  margin-left: 29px;
  margin-top: 34px;
}
.school_logo19 img{
  width: 156px;
  height: 48px;
  margin-left: 17px;
  margin-top: 34px;
}
.school_logo20 img{
  width: 174px;
  height: 47px;
  margin-left: 13px;
  margin-top: 34px;
}
.school_logo21 img{
  width: 165px;
  height: 47px;
  margin-left: 15px;
  margin-top: 34px;
}

.friendLink2{
  margin-top: 82px;
}
.friendLink2List{
  margin-top: 4.569999999999993px;
  width: 1388px;
  text-align: justify;
}
.friendLink2List a{
  height: 16px;
  font-size: 16px;
  font-family: AlibabaPuHuiTi-Regular55,微软雅黑;
  color: #1B1B1B;
  line-height: 38px;
  margin-right: 28px;
}
.friendLink2List a:hover{
  color: #30A263;
  text-decoration: underline;
}

/* start end5 */

.goCheckOutter{
  width: 100%;
  height: 242px;
  background: linear-gradient(-9deg, #30A263, #38B671);
  background-image: url(../../../static/img/bg8.png);
  background-size: 100%;
  background-repeat:no-repeat;
  box-sizing: border-box;
  overflow: hidden;
}
.goCheckDesc{
  width: 100%;
  text-align: center;
  height: 41px;
  font-size: 41px;
  line-height: 41px;
  font-family: PingFangSC-Semibold,微软雅黑;
  font-style: italic;
  color: #FFFFFF;
  margin-top: 69px;
}
.goCheckBtn{
  width: 198px;
  height: 59px;
  line-height: 59px;
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  margin: 42px auto 0px;
  text-align: center;
  font-size: 18px;
  font-family: PingFangSC-Regular,微软雅黑;
  font-weight: 400;
  color: #FFFFFF;
  cursor: pointer;
}
.jifenhuodongMask{
  width: 100%;
  height: 100%;
  position:fixed;
  left: 0px;
  top:0px;
  background:black;
  z-index: 9999999;
  opacity: .6;
}
.jifenhuodongMaskImg{
  left:50%;
  top: 50%;
  z-index: 9999999999;
  position:fixed;
  /*margin-left: -345px;
  margin-top: -217.79999999999998px;
  width: 690px;
  height: 435.59999999999997px;*/
}
.closejifen{
  left:50%;
  top: 50%;
  z-index: 9999999999;
  position:fixed;
  cursor: pointer;
}
.jifenDescCon{
  left:50%;
  top: 50%;
  z-index: 99999999999;
  position:fixed;
  box-sizing: border-box;
}
.jifenDescCon div{
  font-size: 12px;
  text-align:justify;
  padding-left: 101px;
  margin-bottom:10px;
  font-family: AlibabaPuHuiTi_2_55_Regular,微软雅黑;
  font-weight: normal;
  color: #A2C0FF;
  line-height: 20px;
  position: relative;
}
.jifenDescCon div p{
  display: block;
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #F0B24D;
  left: 84px;
  top: 6px;
}
/* start end6 */
.avatorUrl{
  display: block;
  width:128px;
  height:auto;
  border-radius: 50%;
  margin:52px auto 0px;
  box-sizing:border-box;
}
.nickName{
  text-align: center;
  line-height: 16px;
  height: 16px;
  font-size: 16px;
  margin-top: 22px;
  font-family: PingFangSC-Regular,微软雅黑;
  font-weight: 400;
  color: #222222;
}
.logined {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.checkcenter{
  margin:38px auto 0px;
  background: #30A263;
  color: #FFFFFF;
}
.viewReport{
  margin:14px auto 0px;
  color: #30A263;
  background: #FFFFFF;
  border: 1px solid #30A263;
}
.logout{
  margin:14px auto 0px;
  background: #FFFFFF;
  border: 1px solid #F55656;
  color: #F55656;
}
/* start end7 */
/* 新的部分 */
</style>

<style>
/* 修改dialog的样式 begin */
.el-dialog__headerbtn {
  top: 20px !important;
  background: url("../../../static/img/icon_close.png") left no-repeat !important;
  width: 20px;
  height: 20px;
  background-size: contain !important;
}
.el-dialog__headerbtn i {
  visibility: hidden;
}
.login_dialog > div:nth-child(1) {
  border-radius: 10px;
}
/* 修改dialog的样式 end */

/* 首页轮播图修改 begin */
.loginForm > img {
  border-radius: 15px;
}
.loginFormTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}
.loginFormTitle > span {
  font-size: 10px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFDFD;
  line-height: 14px;
  text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.5);
  float: left;
}
.loginWeixin {
  display: flex;
  font-size: 10px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  line-height: 14px;
  height: 34px !important;
}
.weixinTitle {
  color: #ffffff;
  white-space: nowrap;
  font-size: 16px;
}
.loginDesc {
  margin: 0 auto;
  font-size: 10px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
}
.loginBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FDBE12;
  border-radius: 6px;
  border: 0px;
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  cursor: pointer;
}
.headBanner {
  position: absolute;
  top: 0;
}
.el-carousel__container {
  overflow-y: hidden;
  overflow-x: hidden;
  height: 400px !important;
}
.el-carousel__item {
  height: 300px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  margin: 0;
}
.el-carousel__item:nth-child(3n) {
  background: url('../../../static/img/index-bg-mid-1.png') 0 0 no-repeat;
  background-size: contain;
  background-position: center center;
}
.el-carousel__item:nth-child(3n+1) {
  background: url('../../../static/img/index-bg-mid-2.png') 0 0 no-repeat;
  background-size: contain;
  background-position: center center;
}
.el-carousel__item:nth-child(3n+2) {
  background: url('../../../static/img/index-bg-mid-3.png') 0 0 no-repeat;
  background-size: contain;
  background-position: center center;
}
.waitLogin {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.indexBox1 {
  display: flex;
  justify-content: space-between;
}
/* 首页轮播图修改 end */
</style>



// WEBPACK FOOTER //
// src/components/IndexNew/IndexNew.vue